const NS = 'CourseDetailsSocialShareWidget';
const CLS = 'courseDetailsSocialShareWidget';

import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';

export class CourseDetailsSocialShareWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$icons = this.$element.find(`.${CLS}-icons`);
		this.urlToShare = this.$element.data('urlToShare');
		this.$shareButtons = this.$icons.find(`.${CLS}-button`);

		this.$shareButtons.each((index, element) => {
			let $element = $(element);
			if($element.data('appendLink')) {
				$element.attr('href', $element.attr('href') + this.urlToShare);
			}
		});

		this.$element.hover(() => {
			this.$shareButtons.each((index, element) => {
				// Deals with positioning
				if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.MD)) {
					$(element).css({
						bottom: `${30 * ((this.$shareButtons.length - index))}px`
					});
				}
				else {
					$(element).css({
						bottom: `-${30 * (1 + index)}px`
					});
				}
			});
		}, () => {
			let $shareButtons = this.$icons.find(`.${CLS}-button`);
			$shareButtons.each((_index, element) => {
				$(element).css({
					bottom: 0
				});
			});
		});
	}
}
